import { inject } from 'mobx-react';
import { IObservableArray } from 'mobx';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { ImageViewModel } from 'models';

import { ToolbarType } from 'uitk-react-toolbar';
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from 'uitk-react-media-gallery';

interface GalleryDialogProps extends LocalizedComponentProps {
  analytics?: AnalyticsStore;
  currentIndex: number;
  galleryDialogCloseCallback?: () => void;
  galleryDialogOpenCallback?: () => void;
  galleryName: string;
  images: IObservableArray<ImageViewModel> | ImageViewModel[];
  onIndexChange: (index) => void;
  trackingRfrr: string;
}

const GalleryDialogComponent: React.FC<GalleryDialogProps> = inject('analytics')(
  ({ analytics, currentIndex, galleryDialogCloseCallback, galleryName, images, l10n, onIndexChange, trackingRfrr }) => {
    const [showDialog, setShowDialog] = React.useState<boolean>(false);

    React.useEffect(() => {
      setShowDialog(true);
    }, []);

    const toolBarAttributes = {
      iconLabel: l10n.formatText('hotels.infosite.amenities.cancelButton.a11yLabel'),
      type: ToolbarType.CLOSE,
    };

    const toolbarAnalytics = analytics.setupTracker(trackingRfrr, 'Close review gallery dialog');
    const mediaGalleryControlsAnalytics = analytics.setupTracker(trackingRfrr, 'Change image in media gallery');

    return (
      <UitkMediaGalleryImageDialog
        dialogShow={showDialog}
        {...toolBarAttributes}
        analytics={toolbarAnalytics}
        onDismiss={galleryDialogCloseCallback}
      >
        <UitkMediaGalleryImageView
          images={images}
          currentIndex={currentIndex}
          onIndexChange={onIndexChange}
          galleryName={galleryName}
          analytics={mediaGalleryControlsAnalytics}
        />
      </UitkMediaGalleryImageDialog>
    );
  }
);

export const GalleryDialog = withLocalization(GalleryDialogComponent) as React.ComponentType<GalleryDialogProps>;
